import { BOOLEAN_AND, BOOLEAN_OR } from '../../topics/redux/constants';

export const TOGGLE_ACTIVE_TAB = 'TOGGLE_ACTIVE_TAB';
export const RETRIEVE_CHARTS_BEGIN = 'RETRIEVE_CHARTS_BEGIN';
export const RETRIEVE_CHARTS_SUCCESS = 'RETRIEVE_CHARTS_SUCCESS';
export const RETRIEVE_CHARTS_FAILURE = 'RETRIEVE_CHARTS_FAILURE';
export const RETRIEVE_SELECTED_CHART_DETAILS_BEGIN = 'RETRIEVE_SELECTED_CHART_DETAILS_BEGIN';
export const RETRIEVE_SELECTED_CHART_DETAILS_SUCCESS = 'RETRIEVE_SELECTED_CHART_DETAILS_SUCCESS';
export const RETRIEVE_SELECTED_CHART_DETAILS_FAILURE = 'RETRIEVE_SELECTED_CHART_DETAILS_FAILURE';
export const RETRIEVE_CATEGORIES_BEGIN = 'RETRIEVE_CATEGORIES_BEGIN';
export const RETRIEVE_CATEGORIES_SUCCESS = 'RETRIEVE_CATEGORIES_SUCCESS';
export const RETRIEVE_CATEGORIES_FAILURE = 'RETRIEVE_CATEGORIES_FAILURE';
export const UPDATE_SELECTED_TOPIC_BEGIN = 'UPDATE_SELECTED_TOPIC_BEGIN';
export const UPDATE_SELECTED_TOPIC_SUCCESS = 'UPDATE_SELECTED_TOPIC_SUCCESS';
export const UPDATE_SELECTED_TOPIC_FAILURE = 'UPDATE_SELECTED_TOPIC_FAILURE';
export const RETRIEVE_TOPICSDROPDOWN_BEGIN = 'RETRIEVE_TOPICSDROPDOWN_BEGIN';
export const RETRIEVE_TOPICSDROPDOWN_SUCCESS = 'RETRIEVE_TOPICSDROPDOWN_SUCCESS';
export const RETRIEVE_TOPICSDROPDOWN_FAILURE = 'RETRIEVE_TOPICSDROPDOWN_FAILURE';
export const RETRIEVE_COMMENTS_BEGIN = 'RETRIEVE_COMMENTS_BEGIN';
export const RETRIEVE_COMMENTS_SUCCESS = 'RETRIEVE_COMMENTS_SUCCESS';
export const RETRIEVE_COMMENTS_FAILURE = 'RETRIEVE_COMMENTS_FAILURE';
export const RESET_COMMENTS_FEEDS_TWEETS_AND_HEADLINES_SUCCESS = 'RESET_COMMENTS_FEEDS_TWEETS_AND_HEADLINES_SUCCESS';
export const FILTER_RETRIEVE_COMMENTS_SUCCESS = 'FILTER_RETRIEVE_COMMENTS_SUCCESS';
export const FILTER_RETRIEVE_COMMENTS_FAILURE = 'FILTER_RETRIEVE_COMMENTS_FAILURE';
export const FILTER_RETRIEVE_COMMENTS_BEGIN = 'FILTER_RETRIEVE_COMMENTS_BEGIN';
export const RETRIEVE_UPLOADED_COMMENTS_BEGIN = 'RETRIEVE_UPLOADED_COMMENTS_BEGIN';
export const RETRIEVE_UPLOADED_COMMENTS_SUCCESS = 'RETRIEVE_UPLOADED_COMMENTS_SUCCESS';
export const RETRIEVE_UPLOADED_COMMENTS_FAILURE = 'RETRIEVE_UPLOADED_COMMENTS_FAILURE';
export const FILTER_RETRIEVE_UPLOADED_COMMENTS_SUCCESS = 'FILTER_RETRIEVE_UPLOADED_COMMENTS_SUCCESS';
export const FILTER_RETRIEVE_UPLOADED_COMMENTS_FAILURE = 'FILTER_RETRIEVE_UPLOADED_COMMENTS_FAILURE';
export const FILTER_RETRIEVE_UPLOADED_COMMENTS_BEGIN = 'FILTER_RETRIEVE_UPLOADED_COMMENTS_BEGIN';

export const RETRIEVE_SOURCES_FILTER_BEGIN = 'RETRIEVE_SOURCES_FILTER_BEGIN';
export const RETRIEVE_SOURCES_FILTER_SUCCESS = 'RETRIEVE_SOURCES_FILTER_SUCCESS';
export const RETRIEVE_SOURCES_FILTER_FAILURE = 'RETRIEVE_SOURCES_FILTER_FAILURE';
export const RETRIEVE_FEEDS_BEGIN = 'RETRIEVE_FEEDS_BEGIN';
export const RETRIEVE_FEEDS_SUCCESS = 'RETRIEVE_FEEDS_SUCCESS';
export const RETRIEVE_FEEDS_FAILURE = 'RETRIEVE_FEEDS_FAILURE';
export const FILTER_RETRIEVE_FEEDS_BEGIN = 'FILTER_RETRIEVE_FEEDS_BEGIN';
export const FILTER_RETRIEVE_FEEDS_SUCCESS = 'FILTER_RETRIEVE_FEEDS_SUCCESS';
export const FILTER_RETRIEVE_FEEDS_FAILURE = 'FILTER_RETRIEVE_FEEDS_FAILURE';
export const RETRIEVE_TWEETS_BEGIN = 'RETRIEVE_TWEETS_BEGIN';
export const RETRIEVE_TWEETS_SUCCESS = 'RETRIEVE_TWEETS_SUCCESS';
export const RETRIEVE_TWEETS_FAILURE = 'RETRIEVE_TWEETS_FAILURE';
export const FILTER_RETRIEVE_TWEETS_BEGIN = 'FILTER_RETRIEVE_TWEETS_BEGIN';
export const FILTER_RETRIEVE_TWEETS_SUCCESS = 'FILTER_RETRIEVE_TWEETS_SUCCESS';
export const FILTER_RETRIEVE_TWEETS_FAILURE = 'FILTER_RETRIEVE_TWEETS_FAILURE';
export const RETRIEVE_HEADLINES_BEGIN = 'RETRIEVE_HEADLINES_BEGIN';
export const RETRIEVE_HEADLINES_SUCCESS = 'RETRIEVE_HEADLINES_SUCCESS';
export const RETRIEVE_HEADLINES_FAILURE = 'RETRIEVE_HEADLINES_FAILURE';
export const FILTER_RETRIEVE_HEADLINES_BEGIN = 'FILTER_RETRIEVE_HEADLINES_BEGIN';
export const FILTER_RETRIEVE_HEADLINES_SUCCESS = 'FILTER_RETRIEVE_HEADLINES_SUCCESS';
export const FILTER_RETRIEVE_HEADLINES_FAILURE = 'FILTER_RETRIEVE_HEADLINES_FAILURE';
export const UPDATE_TOPICSDROPDOWN_BEGIN = 'UPDATE_TOPICSDROPDOWN_BEGIN';
export const UPDATE_TOPICSDROPDOWN_SUCCESS = 'UPDATE_TOPICSDROPDOWN_SUCCESS';
export const UPDATE_TOPICSDROPDOWN_FAILURE = 'UPDATE_TOPICSDROPDOWN_FAILURE';
export const UPDATE_SELECTED_CHARTS_BEGIN = 'UPDATE_SELECTED_CHARTS_BEGIN';
export const UPDATE_SELECTED_CHARTS_SUCCESS = 'UPDATE_SELECTED_CHARTS_SUCCESS';
export const UPDATE_SELECTED_CHARTS_FAILURE = 'UPDATE_SELECTED_CHARTS_FAILURE';
export const UPDATE_COMMENTS_RELEVANT_BEGIN = 'UPDATE_COMMENTS_RELEVANT_BEGIN';
export const UPDATE_COMMENTS_RELEVANT_SUCCESS = 'UPDATE_COMMENTS_RELEVANT_SUCCESS';
export const UPDATE_COMMENTS_RELEVANT_FAILURE = 'UPDATE_COMMENTS_RELEVANT_FAILURE';
export const UPDATE_UPLOADED_COMMENTS_RELEVANT_BEGIN = 'UPDATE_UPLOADED_COMMENTS_RELEVANT_BEGIN';
export const UPDATE_UPLOADED_COMMENTS_RELEVANT_SUCCESS = 'UPDATE_UPLOADED_COMMENTS_RELEVANT_SUCCESS';
export const UPDATE_UPLOADED_COMMENTS_RELEVANT_FAILURE = 'UPDATE_UPLOADED_COMMENTS_RELEVANT_FAILURE';
export const UPDATE_POST_COUNTS_AFTER_COMMENT_RELEVANCE_UPDATED = 'UPDATE_POST_COUNTS_AFTER_COMMENT_RELEVANCE_UPDATED';
export const UPDATE_FEEDS_RELEVANT_BEGIN = 'UPDATE_FEEDS_RELEVANT_BEGIN';
export const UPDATE_FEEDS_RELEVANT_SUCCESS = 'UPDATE_FEEDS_RELEVANT_SUCCESS';
export const UPDATE_FEEDS_RELEVANT_FAILURE = 'UPDATE_FEEDS_RELEVANT_FAILURE';
export const UPDATE_TWEETS_RELEVANT_BEGIN = 'UPDATE_TWEETS_RELEVANT_BEGIN';
export const UPDATE_TWEETS_RELEVANT_SUCCESS = 'UPDATE_TWEETS_RELEVANT_SUCCESS';
export const UPDATE_TWEETS_RELEVANT_FAILURE = 'UPDATE_TWEETS_RELEVANT_FAILURE';
export const UPDATE_HEADLINES_RELEVANT_BEGIN = 'UPDATE_HEADLINES_RELEVANT_BEGIN';
export const UPDATE_HEADLINES_RELEVANT_SUCCESS = 'UPDATE_HEADLINES_RELEVANT_SUCCESS';
export const UPDATE_HEADLINES_RELEVANT_FAILURE = 'UPDATE_HEADLINES_RELEVANT_FAILURE';
export const UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN = 'UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN';
export const UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS = 'UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS';
export const UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE = 'UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE';
export const UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN = 'UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN';
export const UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS = 'UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS';
export const UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE = 'UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE';
export const UPDATE_POST_COUNTS_AFTER_SARCASM_TOGGLED = 'UPDATE_POST_COUNTS_AFTER_SARCASM_TOGGLED';
export const UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN = 'UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN';
export const UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS = 'UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS';
export const UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE = 'UPDATE_TWEETS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE';
export const UPDATE_TOPICSDROPDOWN_ON_ADD_TOPIC = 'UPDATE_TOPICSDROPDOWN_ON_ADD_TOPIC';
export const RETRIEVE_ACTIVE_TOPIC_BEGIN = 'RETRIEVE_ACTIVE_TOPIC_BEGIN';
export const RETRIEVE_ACTIVE_TOPIC_SUCCESS = 'RETRIEVE_ACTIVE_TOPIC_SUCCESS';
export const RETRIEVE_ACTIVE_TOPIC_FAILURE = 'RETRIEVE_ACTIVE_TOPIC_FAILURE';
export const RETRIEVE_SHARE_REPORT_STATUS_BEGIN = 'RETRIEVE_SHARE_REPORT_STATUS_BEGIN';
export const RETRIEVE_SHARE_REPORT_STATUS_SUCCESS = 'RETRIEVE_SHARE_REPORT_STATUS_SUCCESS';
export const RETRIEVE_SHARE_REPORT_STATUS_FAILURE = 'RETRIEVE_SHARE_REPORT_STATUS_FAILURE';
export const RETRIEVE_COMPARE_BEGIN = 'RETRIEVE_COMPARE_BEGIN';
export const RETRIEVE_COMPARE_SUCCESS = 'RETRIEVE_COMPARE_SUCCESS';
export const RETRIEVE_COMPARE_FAILURE = 'RETRIEVE_COMPARE_FAILURE';
export const UPDATE_SOURCE_FILTER = 'UPDATE_SOURCE_FILTER';
export const SEND_SHARE_REPORT_BEGIN = 'SEND_SHARE_REPORT_BEGIN';
export const SEND_SHARE_REPORT_SUCCESS = 'SEND_SHARE_REPORT_SUCCESS';
export const SEND_SHARE_REPORT_FAILURE = 'SEND_SHARE_REPORT_FAILURE';
export const RETRIEVE_CSV_BEGIN = 'RETRIEVE_CSV_BEGIN';
export const RETRIEVE_CSV_SUCCESS = 'RETRIEVE_CSV_SUCCESS';
export const RETRIEVE_CSV_FAILURE = 'RETRIEVE_CSV_FAILURE';
export const RETRIEVE_FEED_DETAILS_BEGIN = 'RETRIEVE_FEED_DETAILS_BEGIN';
export const RETRIEVE_FEED_DETAILS_SUCCESS = 'RETRIEVE_FEED_DETAILS_SUCCESS';
export const RETRIEVE_FEED_DETAILS_FAILURE = 'RETRIEVE_FEED_DETAILS_FAILURE';
// To see a list of which charts correspond to which chart IDS:
//   1. Call the GET charts backend endpoint.
//   2. See https://ihpcscc.atlassian.net/wiki/spaces/SL/pages/14417921/API+-+Social+Listening#GET:-charts
export const UNIMPLEMENTED_CHART_IDS = [110, 111, 112, 113, 114, 115];

export const TAB_NAME_COMMENTS  = 'comments';
export const TAB_NAME_FEEDS     = 'posts';
export const TAB_NAME_TWEETS    = 'tweets';
export const TAB_NAME_HEADLINES = 'headlines';
export const CRAWLED_DATA_SOURCE_KEY = 'crawled_data';
export const UPLOADED_DATA_SOURCE_KEY = 'uploaded_data';

export const CSV_ARTICLE_TYPE_COMMENTS          = 'crawled_comment';
export const CSV_ARTICLE_TYPE_FEEDS             = 'feed';
export const CSV_ARTICLE_TYPE_TWEETS            = 'tweet';
export const CSV_ARTICLE_TYPE_HEADLINES         = 'headlines';
export const CSV_ARTICLE_TYPE_UPLOADED_COMMENTS = 'uploaded_comment';
export const UPLOADED_COMMENTS_CSV_FILENAME_TAG = 'uploaded_comments';
export const TWEET_TEXT                         = CSV_ARTICLE_TYPE_TWEETS;
export const COMMENT_TEXT                       = CSV_ARTICLE_TYPE_COMMENTS;

export const CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE        = {};
CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE[TAB_NAME_COMMENTS]  = CSV_ARTICLE_TYPE_COMMENTS;
CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE[TAB_NAME_FEEDS]     = CSV_ARTICLE_TYPE_FEEDS;
CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE[TAB_NAME_TWEETS]    = CSV_ARTICLE_TYPE_TWEETS;
CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE[TAB_NAME_HEADLINES] = CSV_ARTICLE_TYPE_HEADLINES;
CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE[CSV_ARTICLE_TYPE_UPLOADED_COMMENTS] = CSV_ARTICLE_TYPE_UPLOADED_COMMENTS;


export const ARTICLE_TYPE_BY_CSV_ARTICLE_TYPE                = {};
ARTICLE_TYPE_BY_CSV_ARTICLE_TYPE[CSV_ARTICLE_TYPE_COMMENTS]  = TAB_NAME_COMMENTS;
ARTICLE_TYPE_BY_CSV_ARTICLE_TYPE[CSV_ARTICLE_TYPE_FEEDS]     = TAB_NAME_FEEDS;
ARTICLE_TYPE_BY_CSV_ARTICLE_TYPE[CSV_ARTICLE_TYPE_TWEETS]    = TAB_NAME_TWEETS;
ARTICLE_TYPE_BY_CSV_ARTICLE_TYPE[CSV_ARTICLE_TYPE_HEADLINES] = TAB_NAME_HEADLINES;
ARTICLE_TYPE_BY_CSV_ARTICLE_TYPE[CSV_ARTICLE_TYPE_UPLOADED_COMMENTS] = UPLOADED_COMMENTS_CSV_FILENAME_TAG;

export const SOURCE_NAME_TWITTER          = 'twitter';
export const SOURCE_NAME_ALL_NEWS         = 'all news';
export const SOURCE_NAME_ALL_SOCIAL_MEDIA = 'all social media';
export const ALL_SOURCES                  = 'all sources';

export const SOURCE_TYPE_NEWS = 'news';
export const MAX_FEED_DESCRIPTION_LENGTH_TO_SHOW_BY_DEFAULT = 135;

export const MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB = 135;
export const MAX_COMMENT_TEXT_LENGTH_FOR_FEED_MODAL = 345;
export const DATETIME_FORMAT_FOR_CARD_DISPLAY = 'DD MMM YYYY hh:mm A';

export const COMMENT_VIEW_SHORTCUT_ICON_CLASSES_BY_ARTICLE_TYPE        = {};
COMMENT_VIEW_SHORTCUT_ICON_CLASSES_BY_ARTICLE_TYPE[TAB_NAME_COMMENTS]  = "la-rss-square";
COMMENT_VIEW_SHORTCUT_ICON_CLASSES_BY_ARTICLE_TYPE[TAB_NAME_FEEDS]     = "la-commenting";
COMMENT_VIEW_SHORTCUT_ICON_CLASSES_BY_ARTICLE_TYPE[TAB_NAME_TWEETS]    = "la-twitter";
COMMENT_VIEW_SHORTCUT_ICON_CLASSES_BY_ARTICLE_TYPE[TAB_NAME_HEADLINES] = "la-newspaper-o";

export const COMMENT_VIEW_SHORTCUT_ICON_TOOLTIP_TEXT_BY_ARTICLE_TYPE        = {};
COMMENT_VIEW_SHORTCUT_ICON_TOOLTIP_TEXT_BY_ARTICLE_TYPE[TAB_NAME_COMMENTS]  = "Social Media Comments";
COMMENT_VIEW_SHORTCUT_ICON_TOOLTIP_TEXT_BY_ARTICLE_TYPE[TAB_NAME_FEEDS]     = "Social Media Posts";
COMMENT_VIEW_SHORTCUT_ICON_TOOLTIP_TEXT_BY_ARTICLE_TYPE[TAB_NAME_TWEETS]    = "Tweets";
COMMENT_VIEW_SHORTCUT_ICON_TOOLTIP_TEXT_BY_ARTICLE_TYPE[TAB_NAME_HEADLINES] = "Headlines";
export const TOTAL         = "total"
export const POSITIVE      = "positive";
export const VERY_POSITIVE = "very positive";
export const NEGATIVE      = "negative";
export const VERY_NEGATIVE = "very negative";
export const NEUTRAL       = "neutral";
export const NO_SPECIFIC_EMOTION = "no specific emotion";
export const JOY           = "joy";
export const ANGER         = "anger";
export const FEAR          = "fear";
export const SADNESS       = "sadness";
export const ALL           = "all";
export const CATEGORY_KEY  = "category";
export const SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME = {
  [POSITIVE]: POSITIVE + "," + VERY_POSITIVE,
  [NEGATIVE]: NEGATIVE + "," + VERY_NEGATIVE,
  [NEUTRAL]:  NO_SPECIFIC_EMOTION,
  [JOY]:      JOY,
  [ANGER]:    ANGER,
  [FEAR]:     FEAR,
  [SADNESS]:  SADNESS
}
export const SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_CLICKING_SENTIMENT_TREND_CHART = {
  [POSITIVE]: POSITIVE + "," + VERY_POSITIVE,
  [NEGATIVE]: NEGATIVE + "," + VERY_NEGATIVE,
  [NEUTRAL]:  NEUTRAL
}

export const VERY_POSITIVE_KEY_FOR_CHART_COUNT_CHANGES = "veryPositive";
export const VERY_NEGATIVE_KEY_FOR_CHART_COUNT_CHANGES = "veryNegative";

export const SARCASTIC_LABEL          = "Sarcastic";
export const NOT_SARCASTIC_LABEL      = "Not sarcastic";
export const SARCASTIC_PILL_CLASS     = "sarcastic";
export const NOT_SARCASTIC_PILL_CLASS = "not-sarcastic";
export const NO_SPECIFIC_EMOTION_PILL_CLASS = "no-specific-emotion";

export const SENTIMENT = "Sentiment";
export const EMOTION   = "Emotion";

export const SARCASTIC_COMMENT_COUNT_LABEL = "Sarcastic: ";
export const SARCASTIC_COMMENT_COUNT_HOVER_TEXT = "Number of sarcastic comments";
export const SARCASM_CONFIDENCE_SCORE_HOVER_TEXT = "Sarcasm Confidence Score: ";
export const SARCASM_MANUALLY_TOGGLED_HOVER_TEXT = "Sarcasm label has been toggled";

export const RELEVANT_COMMENT_PILL_CLASS = "all";
export const RELEVANT_COMMENT_COUNT_LABEL = "All: ";
export const RELEVANT_COMMENT_COUNT_HOVER_TEXT = "Total number of comments";

export const GROUP_BY_SENTIMENT_STATE = "Sentiment";
export const GROUP_BY_EMOTION_STATE   = "Emotion";
export const GROUP_BY_BUTTON_LABEL    = "View by: ";
export const GROUP_BY_BUTTON_CLASS    = "group-by-button";

export const SORT_BY_BUTTON_LABEL                   = "Sort by: "; 
export const SORT_BY_BUTTON_CLASS                   = "sort-by-button";
export const SORT_BY_DATE_NEW_TO_OLD_STATE          = "Date (New to Old)";
export const SORT_BY_DATE_OLD_TO_NEW_STATE          = "Date (Old to New)";
export const SORT_BY_SARCASM_SCORE_ASCENDING_STATE  = "Sarcasm Score (Ascending)";
export const SORT_BY_SARCASM_SCORE_DESCENDING_STATE = "Sarcasm Score (Descending)";
export const SORT_BY_COMMENT_COUNT_ASCENDING_STATE  = "Comment Count (Ascending)";
export const SORT_BY_COMMENT_COUNT_DESCENDING_STATE = "Comment Count (Descending)";
export const SORT_BY_CONSTRUCTIVENESS_SCORE_ASCENDING_STATE  = "Constructiveness (Ascending)";
export const SORT_BY_CONSTRUCTIVENESS_SCORE_DESCENDING_STATE = "Constructiveness (Descending)";

export const POST_SORT_TYPE_COMMENT_COUNT_DESCENDING_API_VALUE                                 = 'posts_by_comment_count_descending';
export const POST_SORT_TYPE_COMMENT_COUNT_ASCENDING_API_VALUE                                  = 'posts_by_comment_count_ascending';
export const POST_SORT_TYPE_DATE_NEW_TO_OLD_API_VALUE                                          = 'posts_by_date_new_to_old';
export const POST_SORT_TYPE_DATE_OLD_TO_NEW_API_VALUE                                          = 'posts_by_date_old_to_new';
export const POST_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE                                       = {};
POST_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[POST_SORT_TYPE_DATE_NEW_TO_OLD_API_VALUE]          = SORT_BY_DATE_NEW_TO_OLD_STATE;
POST_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[POST_SORT_TYPE_DATE_OLD_TO_NEW_API_VALUE]          = SORT_BY_DATE_OLD_TO_NEW_STATE;
POST_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[POST_SORT_TYPE_COMMENT_COUNT_ASCENDING_API_VALUE]  = SORT_BY_COMMENT_COUNT_ASCENDING_STATE;
POST_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[POST_SORT_TYPE_COMMENT_COUNT_DESCENDING_API_VALUE] = SORT_BY_COMMENT_COUNT_DESCENDING_STATE;
export const DEFAULT_POST_SORT_TYPE_VALUE                                                      = POST_SORT_TYPE_DATE_NEW_TO_OLD_API_VALUE;

export const COMMENT_SORT_TYPE_DATE_NEW_TO_OLD_VALUE                   = 'comments_by_date_new_to_old';
export const COMMENT_SORT_TYPE_DATE_OLD_TO_NEW_VALUE                   = 'comments_by_date_old_to_new';
export const COMMENT_SORT_TYPE_SARCASM_SCORE_ASCENDING_VALUE           = 'comments_by_sarcasm_ascending';
export const COMMENT_SORT_TYPE_SARCASM_SCORE_DESCENDING_VALUE          = 'comments_by_sarcasm_descending';
export const COMMENT_SORT_TYPE_CONSTRUCTIVENESS_SCORE_ASCENDING_VALUE  = 'comments_by_constructiveness_ascending';
export const COMMENT_SORT_TYPE_CONSTRUCTIVENESS_SCORE_DESCENDING_VALUE = 'comments_by_constructiveness_descending';
export const DEFAULT_COMMENT_SORT_TYPE_VALUE                  = COMMENT_SORT_TYPE_DATE_NEW_TO_OLD_VALUE;
export const COMMENT_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE   = {
  [COMMENT_SORT_TYPE_DATE_NEW_TO_OLD_VALUE]:                   SORT_BY_DATE_NEW_TO_OLD_STATE,
  [COMMENT_SORT_TYPE_DATE_OLD_TO_NEW_VALUE]:                   SORT_BY_DATE_OLD_TO_NEW_STATE,
  [COMMENT_SORT_TYPE_SARCASM_SCORE_ASCENDING_VALUE]:           SORT_BY_SARCASM_SCORE_ASCENDING_STATE,
  [COMMENT_SORT_TYPE_SARCASM_SCORE_DESCENDING_VALUE]:          SORT_BY_SARCASM_SCORE_DESCENDING_STATE,
  [COMMENT_SORT_TYPE_CONSTRUCTIVENESS_SCORE_ASCENDING_VALUE]:  SORT_BY_CONSTRUCTIVENESS_SCORE_ASCENDING_STATE,
  [COMMENT_SORT_TYPE_CONSTRUCTIVENESS_SCORE_DESCENDING_VALUE]: SORT_BY_CONSTRUCTIVENESS_SCORE_DESCENDING_STATE
};

export const COMMENT_SORT_OPTIONS                   = [
                                                      SORT_BY_DATE_NEW_TO_OLD_STATE,
                                                      SORT_BY_DATE_OLD_TO_NEW_STATE,
                                                      SORT_BY_SARCASM_SCORE_ASCENDING_STATE,
                                                      SORT_BY_SARCASM_SCORE_DESCENDING_STATE,
                                                      SORT_BY_CONSTRUCTIVENESS_SCORE_ASCENDING_STATE,
                                                      SORT_BY_CONSTRUCTIVENESS_SCORE_DESCENDING_STATE
                                                    ];
export const POST_SORT_OPTIONS                      = [
                                                      SORT_BY_DATE_NEW_TO_OLD_STATE,
                                                      SORT_BY_DATE_OLD_TO_NEW_STATE,
                                                      SORT_BY_COMMENT_COUNT_ASCENDING_STATE,
                                                      SORT_BY_COMMENT_COUNT_DESCENDING_STATE
                                                    ];
export const COMMENT_SORT_STATE_TO_VALUE_MAP        = {
  [SORT_BY_DATE_NEW_TO_OLD_STATE]:                   COMMENT_SORT_TYPE_DATE_NEW_TO_OLD_VALUE,
  [SORT_BY_DATE_OLD_TO_NEW_STATE]:                   COMMENT_SORT_TYPE_DATE_OLD_TO_NEW_VALUE,
  [SORT_BY_SARCASM_SCORE_ASCENDING_STATE]:           COMMENT_SORT_TYPE_SARCASM_SCORE_ASCENDING_VALUE,
  [SORT_BY_SARCASM_SCORE_DESCENDING_STATE]:          COMMENT_SORT_TYPE_SARCASM_SCORE_DESCENDING_VALUE,
  [SORT_BY_CONSTRUCTIVENESS_SCORE_ASCENDING_STATE]:  COMMENT_SORT_TYPE_CONSTRUCTIVENESS_SCORE_ASCENDING_VALUE,
  [SORT_BY_CONSTRUCTIVENESS_SCORE_DESCENDING_STATE]: COMMENT_SORT_TYPE_CONSTRUCTIVENESS_SCORE_DESCENDING_VALUE
};
export const POST_SORT_STATE_TO_VALUE_MAP           = {
  [SORT_BY_DATE_NEW_TO_OLD_STATE]:          POST_SORT_TYPE_DATE_NEW_TO_OLD_API_VALUE,
  [SORT_BY_DATE_OLD_TO_NEW_STATE]:          POST_SORT_TYPE_DATE_OLD_TO_NEW_API_VALUE,
  [SORT_BY_COMMENT_COUNT_ASCENDING_STATE]:  POST_SORT_TYPE_COMMENT_COUNT_ASCENDING_API_VALUE,
  [SORT_BY_COMMENT_COUNT_DESCENDING_STATE]: POST_SORT_TYPE_COMMENT_COUNT_DESCENDING_API_VALUE       
};

export const MAXIMUM_DECIMAL_PLACES_FOR_SARCASM_SCORE = 5;
export const MARKED_AS_IRRELEVANT_LABEL = '*Marked as irrelevant';

export const LOCAL_STORAGE_KEY_FOR_HAS_ACCEPTED_FB_DATA_COMPLIANCE_AGREEMENT = 'hasAcceptedFBDataComplianceAgreement';
export const LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_RELEVANT_POP_UP = 'hasCheckedDoNotShowRelevantPopUp';
export const LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_SARCASM_TOGGLING_POP_UP = 'hasCheckedDoNotShowSarcasmTogglingPopUp';

export const UPDATING_SOURCES_MSG = "Updating Sources...";

export const FACEBOOK_LOGIN_WARNING_TITLE = "Facebook Login Required";
export const FACEBOOK_LOGIN_WARNING_MSG = "Please login to Facebook to access the dashboard.";
export const FACEBOOK_SOURCE_SELECTION_SUCCESS_MSG = "Facebook source has been selected!";
export const FACEBOOK_SOURCE_SELECTION_ERROR_MSG = "Error selecting Facebook source. Please try again on the sources tab!";

export const CONFIRM_BUTTON_COLOR = '#3085d6';
export const CANCEL_BUTTON_COLOR = '#d33';
export const CONFIRM_BUTTON_TEXT = 'PROCEED';
export const CANCEL_BUTTON_TEXT = 'CANCEL'

export const CONVERT_KEYWORDS_JSON_TO_LIST_TO_USE_FOR_HIGHLIGHTING_MATCHING_TEXT = (topicKeywordsJSON) => {
  let allKeywords  = [];
  if (topicKeywordsJSON.hasOwnProperty(BOOLEAN_AND)) {
    for (let keywordClause of topicKeywordsJSON[BOOLEAN_AND]) {
      if (keywordClause.hasOwnProperty(BOOLEAN_OR)) {
        allKeywords = allKeywords.concat(keywordClause[BOOLEAN_OR]);
      }
    }
  }
  return allKeywords;
};

export const SARCASM_THRESHOLD_DISPLAY_MESSAGE_PARTS = [
  "The sarcasm threshold has been set to ",
  ". All comments and tweets with a sarcasm score of ",
  " or above will be marked as sarcastic."
];
export const SARCASM_LABEL_UPDATED_MESSAGE = 'Sarcasm label has been updated';
export const SARCASM_LABEL_NOT_UPDATED_MESSAGE = 'Sarcasm label has not been updated';
export const SARCASM_POST_COUNT_UPDATE_ERROR_MESSAGE = 'Post counts still do not reflect sarcasm toggling. Please refresh the page.';

export const DAY_UNIT = "day";
export const VALUE_KEY = "value";

export const SENTIMENTS = "sentiments";
export const EMOTIONS = "emotions";

export const NEUTRAL_ICON_FILE_PATH = "/images/icons/comment_card/neutral.svg";
export const POSITIVE_ICON_FILE_PATH = "/images/icons/comment_card/positive.svg";
export const NEGATIVE_ICON_FILE_PATH = "/images/icons/comment_card/negative.svg";
export const SARCASM_ICON_FILE_PATH = "/images/icons/comment_card/sarcasm.svg";
export const CRYSTALFEEL_CATEGORIES_TO_ICONS_MAP = {
  [JOY]:      "/images/icons/comment_card/joy.svg",
  [ANGER]:    "/images/icons/comment_card/anger.svg",
  [FEAR]:     "/images/icons/comment_card/fear.svg",
  [SADNESS]:  "/images/icons/comment_card/sadness.svg",
  [NO_SPECIFIC_EMOTION]: NEUTRAL_ICON_FILE_PATH,
  [NEUTRAL]:             NEUTRAL_ICON_FILE_PATH,
  [POSITIVE]:            POSITIVE_ICON_FILE_PATH,
  [VERY_POSITIVE]:       POSITIVE_ICON_FILE_PATH,
  [NEGATIVE]:            NEGATIVE_ICON_FILE_PATH,
  [VERY_NEGATIVE]:       NEGATIVE_ICON_FILE_PATH
};

export const FADE_IN_CLASS_NAME  = 'fade-in';
export const FADE_OUT_CLASS_NAME = 'fade-out';

export const E_PLUS_TWO  = "e+2";
export const E_MINUS_TWO = "e-2";


// WEBPACK FOOTER //
// ./src/features/home/redux/constants.js